import React, { useState } from 'react';
import { PlusIcon, EditIcon, TrashIcon } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Modal } from '../components/ui/Modal';
import { LenderForm } from '../components/LenderForm';
import { mockLenders } from '../data/mockData';
import { Lender } from '../types';
export function LenderManagement() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLender, setSelectedLender] = useState<Lender | undefined>();
  const handleCreateLender = (lenderData: Omit<Lender, 'id' | 'createdAt' | 'updatedAt'>) => {
    // In real app, this would create the lender
    console.log('Creating lender:', lenderData);
    setIsModalOpen(false);
  };
  const handleEditLender = (lender: Lender) => {
    setSelectedLender(lender);
    setIsModalOpen(true);
  };
  const handleUpdateLender = (lenderData: Omit<Lender, 'id' | 'createdAt' | 'updatedAt'>) => {
    // In real app, this would update the lender
    console.log('Updating lender:', selectedLender?.id, lenderData);
    setIsModalOpen(false);
    setSelectedLender(undefined);
  };
  const handleDeleteLender = (lenderId: string) => {
    if (confirm('Are you sure you want to delete this lender?')) {
      // In real app, this would delete the lender
      console.log('Deleting lender:', lenderId);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLender(undefined);
  };
  return <div className="space-y-6" data-id="element-403">
      <div className="flex items-center justify-between" data-id="element-404">
        <div data-id="element-405">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-406">
            Lender Management
          </h1>
          <p className="text-slate-600 mt-1" data-id="element-407">
            Manage lender accounts and information
          </p>
        </div>
        <Button variant="primary" onClick={() => setIsModalOpen(true)} data-id="element-408">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-409" />
          Add Lender
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-410">
        {mockLenders.map(lender => <Card key={lender.id} className="p-6" data-id="element-411">
            <div className="flex items-start justify-between mb-4" data-id="element-412">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-413">
                {lender.name}
              </h3>
              <div className="flex space-x-2" data-id="element-414">
                <button onClick={() => handleEditLender(lender)} className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Edit lender" data-id="element-415">
                  <EditIcon className="w-4 h-4" data-id="element-416" />
                </button>
                <button onClick={() => handleDeleteLender(lender.id)} className="text-slate-400 hover:text-red-600 transition-colors" aria-label="Delete lender" data-id="element-417">
                  <TrashIcon className="w-4 h-4" data-id="element-418" />
                </button>
              </div>
            </div>

            <div className="space-y-2" data-id="element-419">
              <div data-id="element-420">
                <p className="text-xs text-slate-600" data-id="element-421">FHA Sponsor ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-422">
                  {lender.fhaSponsorId}
                </p>
              </div>
              <div data-id="element-423">
                <p className="text-xs text-slate-600" data-id="element-424">VA Sponsor ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-425">
                  {lender.vaSponsorId}
                </p>
              </div>
              <div data-id="element-426">
                <p className="text-xs text-slate-600" data-id="element-427">Tax ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-428">
                  {lender.taxId}
                </p>
              </div>
              <div data-id="element-429">
                <p className="text-xs text-slate-600" data-id="element-430">Phone</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-431">
                  {lender.phone}
                </p>
              </div>
              <div data-id="element-432">
                <p className="text-xs text-slate-600" data-id="element-433">Email</p>
                <p className="text-sm font-medium text-slate-900 truncate" data-id="element-434">
                  {lender.email}
                </p>
              </div>
              <div data-id="element-435">
                <p className="text-xs text-slate-600" data-id="element-436">Address</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-437">
                  {lender.address.city}, {lender.address.state}
                </p>
              </div>
            </div>
          </Card>)}
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} title={selectedLender ? 'Edit Lender' : 'Add New Lender'} size="lg" data-id="element-438">
        <LenderForm lender={selectedLender} onSubmit={selectedLender ? handleUpdateLender : handleCreateLender} onCancel={handleCloseModal} data-id="element-439" />
      </Modal>
    </div>;
}